import { Accordion, AccordionDetails, AccordionSummary, Card, Typography } from '@mui/material'

interface P {
    error: Error
}

function SpotlightError({ error }: P) {
    let myError: Error = error

    if (error instanceof Error) myError = error
    else if (typeof error === 'string') myError = new Error(error)
    else myError = new Error(error)

    return (
        <Card className='spotlight-container' sx={{ padding: 2 }}>
            <Typography>An error occurred</Typography>
            <Accordion style={{ maxWidth: '80%' }}>
                <AccordionSummary>
                    <Typography>{myError.message}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{ overflowX: 'auto' }}>
                    <pre>
                        {myError.stack}
                    </pre>
                </AccordionDetails>
            </Accordion>
        </Card>
    )
}

export default SpotlightError
